<div class="page">
  <div class="page__container">
    <h1 class="page__title h2">{{ 'shop_cart_title_cart' | translate }}</h1>
    <wsb-atlas-step class="mb-4" [numSteps]="2" [currentStep]="currentStep" [routeStep]="routeStep"></wsb-atlas-step>
    <div class="alert alert-primary" role="alert" *ngIf="displayFraudAlertV2() && currentStep === 2">
      <small class="form-text text-muted" [innerHTML]="'shop_cart_disabled_payments_msg' | translate"></small>
    </div>
    <div class="row my-5" *ngIf="currentStep === 1">
      <div class="col-12">
        <h5 class=" h3  mb-3" translate>shop_cart_title_cart_products</h5>
        <table class="table shopCart" *ngIf="cart?.shopCartItems">
          <thead>
            <tr>
              <th translate>common_description</th>
              <th translate>shop_cart_quantity</th>
              <th translate>shop_cart_unit_price</th>
              <th translate>shop_subscription_totalprice</th>
              <th translate></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cartItem of cart.shopCartItems">
              <td translate="">{{ replaceLabelTagWithValue(cartItem) }}</td>
              <td>
                <input
                  class="item-quantity"
                  type="number"
                  min="1"
                  [max]="cartItem.maxQuantity"
                  [readonly]="updateQuantityInProgress"
                  (change)="updateQuantityItem(cartItem, $event.target.value)"
                  [value]="cartItem.quantity"
                />
              </td>
              <td class="">{{ getCurrencySymbol() + ' ' + cartItem.shopItem.price }}</td>
              <td class="">{{ getCurrencySymbol() + ' ' + cartItem.totalPriceItem }}</td>
              <td class="">
                <wsb-atlas-button class="mb-2" [variant]="'danger'" [icon]="faTrash" (click)="removeItem(cartItem)"></wsb-atlas-button>
              </td>
            </tr>
          </tbody>
          <tfoot *ngIf="cart?.discountCode">
            <tr>
              <td class="code-display" colspan="2">
                <strong translate>shop_cart_coupon_applied</strong>&nbsp;&nbsp;{{ cart.discountCode }}
                <a [routerLink]="[]" class="ms-2" (click)="removeCode()">Remove</a>
              </td>
              <td class="totals"><strong translate>shop_cart_total_discount</strong></td>
              <td id="shop-cart-totaldiscount" class="totals" *ngIf="cart.discountPrice">
                <strong>{{ getCurrencySymbol() + ' ' + cart.discountPrice }}</strong>
              </td>
              <td id="shop-cart-totaldiscount" class="totals" *ngIf="!cart.discountPrice && cart.discountBonusSms">
                <strong translate>shop_cart_coupon_code_freesms</strong>
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="2"></td>
              <td class="totals"><strong translate>shop_cart_total</strong></td>
              <td class="totalprice">
                <strong>{{ getCurrencySymbol() + ' ' + cart.totalPrice }}</strong>
              </td>
              <td width="10" translate></td>
            </tr>
          </tfoot>
          <tfoot *ngIf="!cart?.discountCode">
            <tr>
              <td colspan="2" class="pt-4">
                <a href="#" translate class="me-4" (click)="havePromoCode($event)">shop_cart_coupon_question</a>
                <div class="d-flex flex-column d-inline-flex" *ngIf="getPromoCode">
                  <div class="d-inline-flex">
                    <input
                      type="text"
                      style="width:120px;"
                      class="form-control me-2"
                      [(ngModel)]="promoCode"
                      (ngModelChange)="errorCode = ''"
                    />
                    <button class="btn btn-primary btn-sm" type="button" (click)="addPromoCode($event)" translate>
                      shop_cart_coupon_add
                    </button>
                  </div>
                  <span class="line-error" *ngIf="errorCode">{{ errorCode }}</span>
                </div>
              </td>
              <td class="totals"><strong translate>shop_cart_total</strong></td>
              <td class="totalprice">
                <strong>{{ getCurrencySymbol() + ' ' + cart.totalPrice }}</strong>
              </td>
              <td width="10"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="col-12 d-flex">
        <button #submitBtn class="btn btn-primary btn-sm my-3" [disabled]="!cart?.shopCartItems" (click)="goToSummary()" translate>
          common_next
        </button>
        <button type="button" class="btn  btn-secondary my-3 btn-sm ms-3" routerLink="/shop/index" translate>shop_cart_backtoshop</button>
      </div>
      <div class="col-12 justify-content-center">
        <div class="secure-payment">
          <h4 translate>shop_cart_box_secure_payments_title</h4>
          <p translate>shop_cart_box_secure_payments_description</p>
        </div>
      </div>
    </div>
    <div class="row my-5" *ngIf="currentStep === 2">
      <div class="col-12 d-flex justify-content-around" *ngIf="cart?.shopCartItems">
        <div class="col-5">
          <h3 class=" h3  mb-3" translate>shop_cart_summary_order_title</h3>
          <table class="table shopCart cart-summary">
            <thead>
              <tr>
                <th translate>common_description</th>
                <th translate>shop_cart_quantity</th>
                <th class="text-end" translate>shop_subscription_totalprice</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cartItem of cart.shopCartItems">
                <td translate="">{{ replaceLabelTagWithValue(cartItem) }}</td>
                <td>{{ cartItem.quantity }}</td>
                <td class="text-end">{{ getCurrencySymbol() + ' ' + cartItem.totalPriceItem }}</td>
              </tr>
              <!--                   <tr>
                    <td colspan="2"></td>
                    <td><a routerLink="/shop/index" translate>shop_cart_summary_add_products</a></td>
                  </tr> -->
            </tbody>
            <tfoot *ngIf="cart?.discountCode">
              <tr class="big-border">
                <td colspan="2"><strong translate>shop_cart_total_notdiscounted</strong></td>
                <td class="totals">????</td>
              </tr>
              <tr>
                <td colspan="2" class="totals"><strong translate>shop_cart_total_discount</strong></td>
                <td id="shop-cart-totaldiscount" class="totals">{{ getCurrencySymbol() + ' ' + cart.discountPrice }}</td>
              </tr>
              <tr>
                <td colspan="2" class="totals"><strong translate>shop_cart_total</strong></td>
                <td>{{ getCurrencySymbol() + ' ' + cart.totalPrice }}</td>
              </tr>
              <tr *ngIf="cart.vat">
                <td colspan="2" class="totals"><strong translate>shop_cart_vat</strong></td>
                <td>{{ getCurrencySymbol() + ' ' + cart.vat }}</td>
              </tr>
              <tr>
                <td colspan="2" class="totals"><strong translate>shop_cart_grandtotal</strong></td>
                <td class="totalprice">
                  <strong>{{ getCurrencySymbol() + ' ' + cart.totalPriceToPay }}</strong>
                </td>
              </tr>
            </tfoot>
            <tfoot *ngIf="!cart?.discountCode">
              <tr>
                <td colspan="2" class="totals"><strong translate>shop_cart_total</strong></td>
                <td>{{ getCurrencySymbol() + ' ' + cart.totalPrice }}</td>
              </tr>
              <tr *ngIf="cart.vat">
                <td colspan="2" class="totals"><strong translate>shop_cart_vat</strong></td>
                <td>{{ getCurrencySymbol() + ' ' + cart.vat }}</td>
              </tr>
              <tr>
                <td colspan="2" class="totals"><strong translate>shop_cart_grandtotal</strong></td>
                <td class="totalprice">
                  <strong>{{ getCurrencySymbol() + ' ' + cart.totalPriceToPay }}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="col-5 d-flex align-items-start flex-column">
          <div class="" *ngIf="user?.billing">
            <h3 translate>shop_cart_summary_billing_data</h3>
            <div class="summary-data d-flex align-items-start flex-column">
              <span
                ><strong>{{ user.billing.companyName }}</strong></span
              >
              <span>{{ user.profile.name }} {{ user.profile.surname }}</span>
              <span>{{ user.billing.address }}</span>
              <span>{{ user.billing.zipCode }} {{ user.billing.province }}</span>
              <br />
              <span *ngIf="user.billing.taxCode?.length"><label translate>account_cf</label>&nbsp;{{ user.billing.taxCode }}</span>
              <span *ngIf="user.billing.vatCode?.length"><label translate>account_piva</label>&nbsp;{{ user.billing.vatCode }}</span>
              <span *ngIf="user.billing.paCode?.length"
                ><label translate>settings_account_codice_pa</label>&nbsp;{{ user.billing.paCode }}</span
              >

              <span *ngIf="cart?.cigCode?.length"><label translate>shop_cart_cig</label>{{ cart.cigCode }}</span>
              <br />
              <a routerLink="/shop/cart-billing" translate>shop_cart_summary_change_billing</a>
            </div>
          </div>
          <div class="pt-3 d-flex flex-column">
            <h3 translate>shop_cart_choosepayment</h3>
            <div class="d-flex flex-column">
              <div
                class="form-check-inline "
                *ngIf="paymentMethodOncart?.paymentGateways.indexOf('stripe') > -1"
                [ngClass]="{ 'disable-radio-button': !(paymentMethodOncart?.cartEnabledPaymentMethods)['credit-card'] }"
              >
                <label class="radio-custom">
                  <input
                    type="radio"
                    name="paymentMode"
                    [disabled]="!(paymentMethodOncart?.cartEnabledPaymentMethods)['credit-card']"
                    id="credit_card"
                    [(ngModel)]="paymentMode"
                    [ngModelOptions]="{ standalone: true }"
                    value="credit_card"
                  />
                  <span class="radio-custom__radio"></span>
                  <span class="radio-custom__label" translate>shop_payment_cc_stripe</span>
                </label>
              </div>
              <div
                class="form-check-inline "
                *ngIf="paymentMethodOncart?.paymentGateways.indexOf('paypalpro') > -1"
                [ngClass]="{ 'disable-radio-button': !(paymentMethodOncart?.cartEnabledPaymentMethods)['credit-card'] }"
              >
                <label class="radio-custom pt-2">
                  <input
                    type="radio"
                    name="paymentMode"
                    [disabled]="!(paymentMethodOncart?.cartEnabledPaymentMethods)['credit-card']"
                    id="paypalpro"
                    [(ngModel)]="paymentMode"
                    [ngModelOptions]="{ standalone: true }"
                    value="paypalpro"
                  />
                  <span class="radio-custom__radio"></span>
                  <span class="radio-custom__label" translate>shop_cart_choosepayment_paypalpro</span>
                </label>
              </div>
              <div
                class="form-check-inline "
                *ngIf="(paymentMethodOncart?.userEnabledPaymentMethods)['bank-transfer']"
                [ngClass]="{ 'disable-radio-button': !(paymentMethodOncart?.cartEnabledPaymentMethods)['bank-transfer'] }"
              >
                <label class="radio-custom pt-2">
                  <input
                    type="radio"
                    name="paymentMode"
                    [disabled]="!(paymentMethodOncart?.cartEnabledPaymentMethods)['bank-transfer']"
                    id="bank_transfert"
                    [(ngModel)]="paymentMode"
                    [ngModelOptions]="{ standalone: true }"
                    value="bank_transfert"
                  />
                  <span class="radio-custom__radio"></span>
                  <span class="radio-custom__label" translate>shop_payment_bb</span>
                </label>
              </div>
            </div>
            <div class="mt-2">
              <div class="form-check">
                <label class="form-check-label" for="checkPrivacy">
                  <input class="form-check-input" type="checkbox" name="checkPrivacy" id="checkPrivacy" [(ngModel)]="checkPrivacy" />
                  <span [innerHtml]="'check_privacy' | translate"></span>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label" for="checkTerms">
                  <input class="form-check-input" type="checkbox" name="checkTerms" id="checkTerms" [(ngModel)]="checkTerms" />
                  <span [innerHtml]="'check_terms' | translate"></span>
                </label>
              </div>
              <div class="form-check">
                <label class="form-check-label" for="checkClause" *ngIf="showCheckClause">
                  <input class="form-check-input" type="checkbox" name="checkClause" id="checkClause" [(ngModel)]="checkClause" />
                  <span [innerHtml]="'register_check_terms_2' | translate"></span>
                </label>
              </div>
            </div>
            <div
              id="paypal-button-container"
              class="my-3 secondary mt-2"
              [ngClass]="{ 'disabled-overlay': !checkPrivacy || !checkTerms }"
              [hidden]="paymentMode !== 'paypalpro'"
            ></div>

            <wsb-atlas-button
              [hidden]="paymentMode === 'paypalpro'"
              class="my-3 secondary mt-2 buy-btn"
              variant="secondary"
              [label]="'shop_cart_summary_checkout'"
              [disabled]="!enablePaymentBtn"
              (btnClick)="openModalPayment()"
              >{{ 'shop_cart_summary_checkout' | translate }}</wsb-atlas-button
            >
          </div>
        </div>
      </div>
      <ng-template #modalAcceptTerms let-c="close" let-d="dismiss">
        <wsb-modal (dismiss)="d()" title="{{ 'shop_cart_mustacceptterms_title' | translate }}" (primary)="d()">
          <div body>
            <div class="d-flex flex-column">
              <span *ngIf="!checkTerms || !checkPrivacy || (!checkClause && showCheckClause)" translate>shop_cart_mustacceptterms</span>
            </div>
          </div>
        </wsb-modal>
      </ng-template>

      <ng-template #modalStripePayment let-c="close" let-d="dismiss">
        <wsb-modal cancelButtonEnable="true" (dismiss)="d()" title="{{ 'stripe_payment_modal_header' | translate }}" disabledFooter="true">
          <div body>
            <div class="d-flex flex-column">
              <h6 translate>stripe_input_card_data</h6>
              <div id="card-element" class="mt-3"></div>
              <span class="line-error" *ngIf="errorStripe">{{ errorStripe }}</span>
            </div>
            <div class="d-flex justify-content-end mt-4">
              <wsb-atlas-button
                [loading]="loadingPayment"
                class="my-3"
                variant="primary"
                [label]="'stripe_payment_ok'"
                (click)="pay()"
              ></wsb-atlas-button>
            </div>
          </div>
        </wsb-modal>
      </ng-template>

      <ng-template #modalPaymentMethod let-c="close" let-d="dismiss">
        <wsb-modal
          disabledFooter="true"
          (dismiss)="d()"
          title="{{ 'shop_stripe_payment_source_use_default' | translate }}"
          (primary)="pay()"
        >
          <div body>
            <div class="d-flex flex-column">
              <span translate>shop_stripe_payment_source_selector_text</span>
              <strong
                [translate]="'stripe_card_details'"
                [translateParams]="{ value3: paymentMethod.cardNumber, value2: paymentMethod.cardExpire, value1: paymentMethod.type }"
              ></strong>
              <span translate>shop_stripe_payment_source_selector_text_bottom</span>
              <div class="alert alert-primary mt-2" role="alert">
                <small class="form-text text-muted mt-2" [innerHTML]="'stripe_edit_subscription_will_be_canceled' | translate"></small>
              </div>
            </div>
            <div class="d-flex justify-content-between mt-4">
              <wsb-atlas-button
                class="my-3"
                variant="secondary"
                [label]="'shop_stripe_payment_source_use_new'"
                (click)="forcePaymentNewCard()"
              ></wsb-atlas-button>
              <wsb-atlas-button
                class="my-3"
                variant="primary"
                [label]="'shop_stripe_payment_source_use_default'"
                (click)="pay()"
              ></wsb-atlas-button>
            </div>
          </div>
        </wsb-modal>
      </ng-template>

      <ng-template #modalBankTransfertPayment let-c="close" let-d="dismiss">
        <wsb-modal
          cancelButtonEnable="true"
          (dismiss)="d()"
          title="{{ 'shop_cart_checkout_done_modal' | translate }}"
          disabledFooter="true"
        >
          <div body>
            <div id="printable">
              <h4>{{ 'shop_cart_checkout_confirm_bank' | translate }} {{ cart.idShoppingCart }}</h4>
              <span [innerHTML]="'shop_cart_checkout_confirm_bank_details' | translate" class="zob"></span>
              <table class="table mt-3">
                <tr>
                  <td translate>shop_cart_checkout_confirm_bank_recipient_descr</td>
                  <td class="text-center" translate>payment_bb_recipient</td>
                </tr>
                <tr>
                  <td translate>payment_bb_description</td>
                  <td class="text-center" translate>payment_bb_bank_name</td>
                </tr>
                <tr>
                  <td translate>shop_cart_checkout_confirm_bank_address_descr</td>
                  <td class="text-center" translate>payment_bb_bank_address</td>
                </tr>
                <tr>
                  <td translate>shop_cart_checkout_confirm_bank_iban_descr</td>
                  <td class="text-center" translate>payment_bb_iban</td>
                </tr>
                <tr>
                  <td translate>shop_cart_checkout_confirm_bank_bic_descr</td>
                  <td class="text-center" translate>payment_bb_bic</td>
                </tr>
                <tr>
                  <td translate>shop_cart_checkout_confirm_bank_account_descr</td>
                  <td class="text-center" translate>payment_bb_account</td>
                </tr>
                <tr>
                  <td><strong translate>shop_cart_grandtotal</strong></td>
                  <td class="text-center">
                    <strong>{{ getCurrencySymbol() + ' ' + cart.totalPriceToPay }}</strong>
                  </td>
                </tr>
              </table>
            </div>
            <div class="d-flex justify-content-between mt-4">
              <wsb-atlas-button class="my-3" variant="secondary" [label]="'common_print'" (click)="printBankDetails()"></wsb-atlas-button>
              <wsb-atlas-button
                class="my-3"
                variant="primary"
                [label]="'shop_cart_checkout_done_send'"
                [loading]="loadingPayment"
                (click)="closeBankTransfer()"
                >{{ 'shop_cart_checkout_done_send' | translate }}</wsb-atlas-button
              >
            </div>
          </div>
        </wsb-modal>
      </ng-template>
    </div>
  </div>
</div>
